export const REDIRECT_DELAY_MS = 3000;
export const OTP_MAX_RETRIES_REDIRECT_DELAY_MS = 2000;
export const MAX_OTP_RETRIES = 5;
export const OTP_RESEND_COOLDOWN_S = 30;
export const OTP_CODE_LENGTH = 6;
